export const fmt = (v, digits = 2) => {
  if (v === null || v === undefined || v === "") return "—";
  const n = Number(v);
  if (Number.isNaN(n)) return String(v);
  return n.toFixed(digits);
};

export const fmtPct = (v) => {
  if (v === null || v === undefined) return "—";
  return `${Number(v).toFixed(1)}%`;
};

export const gameTimeLocal = (iso, statusState, statusDetail) => {
  if (statusState === "post") return statusDetail || "Final";
  if (statusState === "in") return statusDetail || "Live";
  if (!iso) return statusDetail || "—";
  try {
    const d = new Date(iso);
    return d.toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" });
  } catch {
    return statusDetail || "—";
  }
};

export const dateLabel = (iso) => {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString(undefined, { weekday: "short", month: "short", day: "numeric" });
  } catch {
    return "";
  }
};

export const updatedLocal = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString(undefined, {
      month: "short", day: "numeric", hour: "numeric", minute: "2-digit",
    });
  } catch {
    return "—";
  }
};

// YYYYMMDD <-> yyyy-mm-dd
export const toApiDate = (d) => d.replaceAll("-", "");
export const toInputDate = (d) => {
  if (!d) return "";
  if (d.includes("-")) return d;
  return `${d.slice(0, 4)}-${d.slice(4, 6)}-${d.slice(6, 8)}`;
};
export const todayInput = () => {
  const d = new Date();
  const p = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
};
export const shiftDate = (input, days) => {
  const d = new Date(`${input}T12:00:00`);
  d.setDate(d.getDate() + days);
  const p = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
};
